import type { ReactNode } from "react";
import { flexRender, getCoreRowModel, useReactTable, type ColumnDef } from "@tanstack/react-table";
import { EmptyState, LoadingState } from "./ui";

export function DataTable<T>({
  data,
  columns,
  emptyTitle = "暂无数据",
  emptyDescription = "同步或导入数据后会显示在这里。",
  loading = false,
}: {
  data: T[];
  columns: ColumnDef<T>[];
  emptyTitle?: string;
  emptyDescription?: string;
  loading?: boolean;
}) {
  const table = useReactTable({ data, columns, getCoreRowModel: getCoreRowModel() });
  if (loading) return <LoadingState />;
  if (!data.length) return <EmptyState title={emptyTitle} description={emptyDescription} />;
  return (
    <div className="table-shell">
      <table className="data-table">
        <thead>
          {table.getHeaderGroups().map((group) => (
            <tr key={group.id}>
              {group.headers.map((header) => (
                <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext()) as ReactNode}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
